import { Alert } from '@/keel';

export const LoginErrorAlert = () => (
  <Alert
    variant="danger"
    title="Username or password not recognized."
    description="Please double check credentials and try again."
  />
);
